import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { api, formatMoney, mediaUrl } from '@/lib/api';
import { CountdownTimer } from '@/components/common/CountdownTimer';
import { useI18n } from '@/context/I18nContext';

export const FlashSaleCarousel = () => {
    const [sales, setSales] = useState([]);
    const { t } = useI18n();

    useEffect(() => {
        let m = true;
        (async () => {
            try { const { data } = await api.get('/flash-sales'); if (m) setSales(data || []); } catch (_) {}
        })();
        return () => { m = false; };
    }, []);

    if (!sales.length) return null;
    return (
        <section className="my-8" data-testid="flash-sales-section">
            <div className="flex items-center gap-2 mb-3">
                <Zap className="h-5 w-5 text-red-600" />
                <h2 className="text-xl font-semibold tracking-tight">{t('flash.title','Ofertas relámpago')}</h2>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {sales.map((s) => {
                    const media = s.ad?.media?.[0]?.url;
                    return (
                        <Link to={`/ad/${s.ad?.id}`} key={s.id} className="group block rounded-2xl overflow-hidden border bg-card shadow-[var(--ok-shadow-sm)] hover:shadow-[var(--ok-shadow-card)] transition-shadow" data-testid={`flash-sale-${s.id}`}>
                            <div className="relative aspect-square bg-secondary">
                                {media && <img src={mediaUrl(media)} alt="" className="w-full h-full object-cover" />}
                                <div className="absolute top-2 left-2 bg-red-600 text-white text-xs font-semibold px-2 py-1 rounded-full flex items-center gap-1"><Zap className="h-3 w-3" />-{Math.round(s.discount_pct)}%</div>
                                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded-full"><CountdownTimer endsAt={s.ends_at} /></div>
                            </div>
                            <div className="p-3">
                                <div className="line-clamp-2 text-sm font-medium">{s.ad?.title}</div>
                                <div className="mt-1 flex items-baseline gap-2">
                                    <span className="text-lg font-semibold text-red-700">{formatMoney(s.sale_price)}</span>
                                    <span className="text-xs line-through text-muted-foreground">{formatMoney(s.original_price)}</span>
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </section>
    );
};
